import { useTrackEventsContextQuery } from 'remote-state/platformIntegrationServiceHooks';
import { useFeatureFlagQuery } from 'remote-state/featureFlagsHooks';
import { FEATURE_FLAGS_KEYS } from 'constants/featureFlags';

const PLG_ACCOUNT_TYPE = 'PLG';

const useIsTrialEnabled = (): boolean => {
    const { data: isTrialPageEnabled } = useFeatureFlagQuery({
        flagKey: FEATURE_FLAGS_KEYS.TRIAL_PAGE,
        defaultValue: false,
    });
    const { data } = useTrackEventsContextQuery(isTrialPageEnabled);
    return isTrialPageEnabled && data?.accountType === PLG_ACCOUNT_TYPE;
}

export default useIsTrialEnabled;